/*****/
export const GET_CUSTOMER_PROFILE = 'GET_CRS_CUSTOMER_PROFILE';
export const GET_CUSTOMER_PROFILE_FAIL = 'GET_CRS_CUSTOMER_PROFILE_FAIL';
export const GET_CUSTOMER_PROFILE_SUCCESS = 'GET_CRS_CUSTOMER_PROFILE_SUCCESS';
/*****/
export const GET_ASSOCIATED_CUSTOMERS = 'GET_ASSOCIATED_CUSTOMERS';
export const GET_ASSOCIATED_CUSTOMERS_FAIL = 'GET_ASSOCIATED_CUSTOMERS_FAIL';
export const GET_ASSOCIATED_CUSTOMERS_SUCCESS =
  'GET_ASSOCIATED_CUSTOMERS_SUCCESS';
/*****/
export const GET_CRS_CLUSTER_INFORMATION = 'GET_CRS_CLUSTER_INFORMATION';
export const GET_CRS_CLUSTER_INFORMATION_FAIL =
  'GET_CRS_CLUSTER_INFORMATION_FAIL';
export const GET_CRS_CLUSTER_INFORMATION_SUCCESS =
  'GET_CRS_CLUSTER_INFORMATION_SUCCESS';
/****/
export const GET_CRS_FEATURE_CODES = 'GET_CRS_FEATURE_CODES';
export const GET_CRS_FEATURE_CODES_SUCCESS = 'GET_CRS_FEATURE_CODES_SUCCESS';
export const GET_CRS_FEATURE_CODES_FAIL = 'GET_CRS_FEATURE_CODES_FAIL';
/****/
export const GET_CRS_TRANSACTION_TYPES = 'GET_CRS_TRANSACTION_TYPES';
export const GET_CRS_TRANSACTION_TYPES_SUCCESS =
  'GET_CRS_TRANSACTION_TYPES_SUCCESS';
export const GET_CRS_TRANSACTION_TYPES_FAIL = 'GET_CRS_TRANSACTION_TYPES_FAIL';
/****/
export const GET_CRS_FEATURE_CATEGORY_CODES = 'GET_CRS_FEATURE_CATEGORY_CODES';
export const GET_CRS_FEATURE_CATEGORY_SUCCESS =
  'GET_CRS_FEATURE_CATEGORY_SUCCESS';
export const GET_CRS_FEATURE_CATEGORY_FAIL = 'GET_CRS_FEATURE_CATEGORY_FAIL';
/****/
export const GET_CRS_TRANSACTION_PRODUCT_MAPPING =
  'GET_CRS_TRANSACTION_PRODUCT_MAPPING';
export const GET_CRS_TRANSACTION_PRODUCT_MAPPING_SUCCESS =
  'GET_CRS_TRANSACTION_PRODUCT_MAPPING_SUCCESS';
export const GET_CRS_TRANSACTION_PRODUCT_MAPPING_FAIL =
  'GET_CRS_TRANSACTION_PRODUCT_MAPPING_FAIL';
/****/
export const GET_CRS_HIST_ALERT = 'GET_CRS_HIST_ALERT';
export const GET_CRS_HIST_ALERT_SUCCESS = 'GET_CRS_HIST_ALERT_SUCCESS';
export const GET_CRS_HIST_ALERT_FAIL = 'GET_CRS_HIST_ALERT_FAIL';
/****/
export const GET_CRS_TRANSACTION = 'GET_CRS_TRANSACTION';
export const GET_CRS_TRANSACTION_SUCCESS = 'GET_CRS_TRANSACTION_SUCCESS';
export const GET_CRS_TRANSACTION_FAIL = 'GET_CRS_TRANSACTION_FAIL';
/****/
export const GET_CRS_RISK_INDICATOR = 'GET_CRS_RISK_INDICATOR';
export const GET_CRS_RISK_INDICATOR_FAIL = 'GET_CRS_RISK_INDICATOR_FAIL';
export const GET_CRS_RISK_INDICATOR_SUCCESS = 'GET_CRS_RISK_INDICATOR_SUCESS';
/****/
export const GET_CRS_RISK_INDICATOR_GRAPH = 'GET_CRS_RISK_INDICATOR_GRAPH';
export const GET_CRS_RISK_INDICATOR_GRAPH_SUCCESS =
  'GET_CRS_RISK_INDICATOR_GRAPH_SUCESS';
export const GET_CRS_RISK_INDICATOR_GRAPH_FAIL =
  'GET_CRS_RISK_INDICATOR_GRAPH_FAIL';
/****/
export const GET_CRS_MODEL_EXPLAINABILITY_DATA =
  'GET_CRS_MODEL_EXPLAINABILITY_DATA';
export const GET_CRS_MODEL_EXPLAINABILITY_DATA_SUCCESS =
  'GET_CRS_MODEL_EXPLAINABILITY_DATA_SUCCESS';
export const GET_CRS_MODEL_EXPLAINABILITY_DATA_FAIL =
  'GET_CRS_MODEL_EXPLAINABILITY_DATA_FAIL';
/****/
export const GET_CRS_MODEL_EXPLAINABILITY_STATS =
  'GET_CRS_MODEL_EXPLAINABILITY_STATS';
export const GET_CRS_MODEL_EXPLAINABILITY_STATS_SUCCESS =
  'GET_CRS_MODEL_EXPLAINABILITY_STATS_SUCCESS';
export const GET_CRS_MODEL_EXPLAINABILITY_STATS_FAIL =
  'GET_CRS_MODEL_EXPLAINABILITY_STATS_FAIL';
/****/
export const GET_CRS_TREND_ANALYSIS_DATA = 'GET_CRS_TREND_ANALYSIS_DATA';
export const GET_CRS_TREND_ANALYSIS_DATA_SUCCESS =
  'GET_CRS_TREND_ANALYSIS_DATA_SUCCESS';
export const GET_CRS_TREND_ANALYSIS_DATA_FAIL =
  'GET_CRS_TREND_ANALYSIS_DATA_FAIL';
/****/
export const GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA =
  'GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA';
export const GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_SUCCESS =
  'GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_SUCCESS';
export const GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_FAIL =
  'GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_FAIL';
/****/
export const UPDATE_CRS_RISK_SCORE_HISTORY = 'UPDATE_CRS_RISK_SCORE_HISTORY';
export const UPDATE_CRS_RISK_SCORE_HISTORY_SUCCESS =
  'UPDATE_CRS_RISK_SCORE_HISTORY_SUCCESS';
export const UPDATE_CRS_RISK_SCORE_HISTORY_FAIL =
  'UPDATE_CRS_RISK_SCORE_HISTORY_FAIL';
/****/
export const GET_CRS_RISK_SCORE_HISTORY = 'GET_CRS_RISK_SCORE_HISTORY';
export const GET_CRS_RISK_SCORE_HISTORY_SUCCESS =
  'GET_CRS_RISK_SCORE_HISTORY_SUCCESS';
export const GET_CRS_RISK_SCORE_HISTORY_FAIL =
  'GET_CRS_RISK_SCORE_HISTORY_FAIL';
/****/
export const PUT_RISK_SCORE_ACCEPTANCE = 'PUT_RISK_SCORE_ACCEPTANCE';
export const PUT_RISK_SCORE_ACCEPTANCE_SUCCESS =
  'PUT_RISK_SCORE_ACCEPTANCE_SUCCESS';
export const PUT_RISK_SCORE_ACCEPTANCE_FAIL = 'PUT_RISK_SCORE_ACCEPTANCE_FAIL';
/****/

export function getCustomerProfileData(payload, status) {
  const cpObject = {
    getData: {
      type: GET_CUSTOMER_PROFILE,
      payload
    },
    getFailData: {
      type: GET_CUSTOMER_PROFILE_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CUSTOMER_PROFILE_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function getAssociatedCustomersData(payload, status) {
  const cpObject = {
    getData: {
      type: GET_ASSOCIATED_CUSTOMERS,
      payload
    },
    getFailData: {
      type: GET_ASSOCIATED_CUSTOMERS_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_ASSOCIATED_CUSTOMERS_SUCCESS,
      payload
    }
  };
  return cpObject[status];
}

export function getCRSClusterInformationData(payload, status) {
  const ciObject = {
    getData: {
      type: GET_CRS_CLUSTER_INFORMATION,
      payload
    },
    getFailData: {
      type: GET_CRS_CLUSTER_INFORMATION_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_CLUSTER_INFORMATION_SUCCESS,
      payload
    }
  };
  return ciObject[status];
}

export function getCRSFeatureCodesData(payload, status) {
  /****/
  const ciObject = {
    getData: {
      type: GET_CRS_FEATURE_CODES,
      payload
    },
    getFailData: {
      type: GET_CRS_FEATURE_CODES_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_FEATURE_CODES_SUCCESS,
      payload
    }
  };
  return ciObject[status];
}

export function getCRSTransactionTypesData(payload, status) {
  const CTTDObject = {
    getData: {
      type: GET_CRS_TRANSACTION_TYPES,
      payload
    },
    getFailData: {
      type: GET_CRS_TRANSACTION_TYPES_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_TRANSACTION_TYPES_SUCCESS,
      payload
    }
  };
  return CTTDObject[status];
}

export function getCRSFeatureCategoryCodesData(payload, status) {
  const CFCTObject = {
    getData: {
      type: GET_CRS_FEATURE_CATEGORY_CODES,
      payload
    },
    getFailData: {
      type: GET_CRS_FEATURE_CATEGORY_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_FEATURE_CATEGORY_SUCCESS,
      payload
    }
  };
  return CFCTObject[status];
}

export function getCRSTransactionProductMappingData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_TRANSACTION_PRODUCT_MAPPING,
      payload
    },
    getFailData: {
      type: GET_CRS_TRANSACTION_PRODUCT_MAPPING_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_TRANSACTION_PRODUCT_MAPPING_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSTransactionHistoryData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_TRANSACTION,
      payload
    },
    getFailData: {
      type: GET_CRS_TRANSACTION_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_TRANSACTION_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSAlertHistoryData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_HIST_ALERT,
      payload
    },
    getFailData: {
      type: GET_CRS_HIST_ALERT_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_HIST_ALERT_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSRiskIndicatorData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_RISK_INDICATOR,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_INDICATOR_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_INDICATOR_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}
export function getCRSRiskIndicatorGraphData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_RISK_INDICATOR_GRAPH,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_INDICATOR_GRAPH_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_INDICATOR_GRAPH_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSModelExplainabilityData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_DATA,
      payload
    },
    getFailData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_DATA_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_DATA_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSModelExplainabilityStats(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_STATS,
      payload
    },
    getFailData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_STATS_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_MODEL_EXPLAINABILITY_STATS_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSTrendAnalysisData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_TREND_ANALYSIS_DATA,
      payload
    },
    getFailData: {
      type: GET_CRS_TREND_ANALYSIS_DATA_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_TREND_ANALYSIS_DATA_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSClusterViewDescriptionCodesData(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA,
      payload
    },
    getFailData: {
      type: GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_CLUSTER_VIEW_DESCRIPTION_DATA_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function updateCRSRiskScoreHistory(payload, status) {
  const CTPMObject = {
    getData: {
      type: UPDATE_CRS_RISK_SCORE_HISTORY,
      payload
    },
    getFailData: {
      type: UPDATE_CRS_RISK_SCORE_HISTORY_FAIL,
      payload
    },
    getSuccessData: {
      type: UPDATE_CRS_RISK_SCORE_HISTORY_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function getCRSRiskScoreHistory(payload, status) {
  const CTPMObject = {
    getData: {
      type: GET_CRS_RISK_SCORE_HISTORY,
      payload
    },
    getFailData: {
      type: GET_CRS_RISK_SCORE_HISTORY_FAIL,
      payload
    },
    getSuccessData: {
      type: GET_CRS_RISK_SCORE_HISTORY_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}

export function putRiskScoreAcceptance(payload, status) {
  const CTPMObject = {
    getData: {
      type: PUT_RISK_SCORE_ACCEPTANCE,
      payload
    },
    getFailData: {
      type: PUT_RISK_SCORE_ACCEPTANCE_FAIL,
      payload
    },
    getSuccessData: {
      type: PUT_RISK_SCORE_ACCEPTANCE_SUCCESS,
      payload
    }
  };
  return CTPMObject[status];
}
